//any side effects or async calls

import { put } from "redux-saga/effects";
import request from "../../utils/request";
import { call } from "redux-saga/effects";
import { responseDetailSuccess, requestAttachmentData } from "../actions/responseDetailAction";
import { toast } from "react-toastify";
import { SUPPLIER_PATH } from "../../config/path";


export function* getDetails(action) {
    const requestURL = `${SUPPLIER_PATH}/open-existing-request?requestId=${action.payload}`;

    const requestAttrs = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
    };
    try {
        const response = yield call(request, requestURL, requestAttrs);
        let data = response.rows[0].requestDetails;
        yield put(responseDetailSuccess(data ? data : []));
    } catch (err) {
        toast.error("Failed to load data, please reload.", { autoClose: false });
    }
}

export function* requestAttachmentSaga(action) {
    const requestURL = `${SUPPLIER_PATH}/get-attachments?vendorRequestId=${action.payload}`

    const requestAttrs = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
    }

    try {
        const attachmentResponse = yield call(request, requestURL, requestAttrs);
        yield put(requestAttachmentData((attachmentResponse && attachmentResponse.rows[0]) ? attachmentResponse.rows[0].dataResult : []))
    } catch (err) {
    }
}

